import RegisterModel from '../models/register.model';
import { ErrorHandler } from '../../../../assets/js';
import { validate } from 'vee-validate';

export default {
	state: {
		RegisterModel,
		setUpId: '',
		action: 0,
		title: '',
		description: '',
		hasError: false,
		isConfirmed: false,
	},
	getters: {
		RegisterModel: (state) => {
			return state.RegisterModel;
		},
		setUpId: (state) => {
			return state.setUpId;
		},
		action: (state) => {
			return state.action;
		},
		title: (state) => {
			return state.title;
		},
		description: (state) => {
			return state.description;
		},
		hasError: (state) => {
			return state.hasError;
		},
		isConfirmed: (state) => {
			return state.isConfirmed;
		},
	},
	mutations: {
		setRegisterModel(state, RegisterModel) {
			state.RegisterModel = RegisterModel;
		},
		setUpId(state, setUpId) {
			state.setUpId = setUpId;
		},
		action(state, action) {
			state.action = action;
		},
		title(state, title) {
			state.title = title;
		},
		description(state, description) {
			state.description = description;
		},
		hasError(state, hasError) {
			state.hasError = hasError;
		},
		isConfirmed(state, isConfirmed) {
			state.isConfirmed = isConfirmed;
		},
	},
	actions: {
		logIn() {
			Event.$emit('auth:show', { login: true, register: false });
		},
		Register() {
			Event.$emit('auth:show', { login: false, register: true });
		},
		async tokenIsValid(ctx, token) {
			let res = await validate(token, 'required|min:80|max:500', {
				name: 'token',
			});

			if (res && !res.valid) {
				ctx.commit('hasError', true);
				ctx.commit('title', 'Invalid Token');
				ctx.commit('description', res.errors[0]);

				return false;
			} else {
				ctx.commit('hasError', false);
				ctx.commit('isConfirmed', false);
			}

			return true;
		},
		async registerUser(ctx, ref) {
			try {
				ctx.commit('loading', true);
				let data = utils.parseData(
					ctx.getters.RegisterModel.forms.register,
				);

				if (await ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'registration',
							action: 'add',
							data: {
								first_name: data.firstName,
								last_name: data.lastName,
								email: data.email,
							},
						},
						'/home',
					);

					$notify(
						'success',
						'Token Sent',
						'A Verification token has been sent to your email.',
					);
					Event.$emit('auth:show', { register: false });
				}

				ctx.commit('loading', false);
			} catch (err) {
				errHandler.handleError(err);
				ctx.commit('loading', false);
			}
		},
		async verifyToken(ctx, token) {
			try {
				if (await ctx.dispatch('tokenIsValid', token)) {
					let res = await api.fetchEndpoint(
						{
							resource: 'registration',
							action: 'validation',
							data: {
								email_token: token,
							},
						},
						'/home',
					);

					$session.set('setUpId', res.result.registration_setup_id);
					ctx.commit('setUpId', res.result.registration_setup_id);
					ctx.dispatch('showPasswordForm');
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				ctx.commit('hasError', true);

				if (err.err_code === 'INVALID_REGISTRATION_STATUS') {
					ctx.commit('title', 'Token Used');
					ctx.commit(
						'description',
						'The token provided has already been used',
					);
				} else if (err.err_code === 'EMAIL_TOKEN_EXPIRED') {
					ctx.commit('action', 1);
					ctx.commit('title', 'Token Expired');
					ctx.commit(
						'description',
						'The token provided is expired. Click the button below to refresh.',
					);
				} else if (err.err_code === 'EMAIL_TOKEN_ERROR') {
					ctx.commit('action', 2);
					ctx.commit('title', 'Token Invalid');
					ctx.commit(
						'description',
						'The token provided is invalid. If you are yet to register,',
					);
				} else {
					if (err.code) {
						ctx.commit('title', err.err_code);
						ctx.commit('description', err.err_msg);
					}
					errHandler.handleError(err);
				}
			}
		},
		async setUpPassword(ctx, ref) {
			try {
				ctx.commit('loading', true);
				let data = utils.parseData(
					ctx.getters.RegisterModel.forms.passwordSetup,
				);

				let status = await ref.isValid();
				if (await ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'registration',
							action: 'credential',
							data: {
								registration_setup_id: ctx.getters.setUpId,
								tnc: data.terms,
								username: data.username,
								password: data.confirmPassword,
							},
						},
						'/home',
					);

					await $session.remove('setUpId');
					ctx.commit('isConfirmed', true);
					$notify(
						'success',
						'Password Setup',
						`The password for ${data.username} was successfully setup!`,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				errHandler.handleError(err);
				ctx.commit('loading', false);
			}
		},
		showPasswordForm(ctx) {
			ctx.commit('isConfirmed', false);
			ctx.commit('hasError', false);
			Event.$emit('loader:show', false);
		},
	},
};
